import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/connexion", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        const target = ["admin", "super_admin", "staff"].includes(data.role) ? "/admin" : "/profil";
        navigate(target, { replace: true, state: { user: data } });
      } catch (e) {
        window.history.replaceState(null, "", window.location.pathname);
        setError("Échec de la connexion Google : le lien de session a expiré ou a déjà été utilisé. Veuillez réessayer.");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-[#050505] px-6 text-center">
      <p className="text-[#D4AF37]" data-testid="auth-callback-status">{error || "Connexion en cours…"}</p>
      {error && (
        <button
          data-testid="auth-callback-retry"
          onClick={() => navigate("/connexion", { replace: true })}
          className="btn-gold !py-2.5 !px-8 text-sm"
        >
          Retour à la connexion
        </button>
      )}
    </div>
  );
}
